import { render } from "./actions.vue?vue&type=template&id=781d7969"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"

import "./actions.vue?vue&type=style&index=0&id=781d7969&lang=scss"
/* custom blocks */
import block0 from "./actions.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(script)
import block1 from "./actions.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__